<template>
  <section id="vic-results">
    <article>
      <div class="header row clearfix">
        <img src="@/assets/img/2018/map-vic.png">

        <h1>Victoria</h1>
      </div>
      <div class="row clearfix">
        <figure class="sixcol chart">
          <h2>State Trends</h2>

          <div class="chart-wrapper">
            <highcharts class="graphcontainer" :options="trends"></highcharts>
            <div class="nb" style="text-align: right;width: 320px;bottom: -30px;">NB: 2018 figures have been updated since the previous Report was released to account for an error in the data received.</div>
          </div>
        </figure>
        <figure class="sixcol chart last">
          <h2>Category Share</h2>
          <p style="font-size:0.8em"></p>

          <ul class="switches">
            <li><a href="javascript:;" :class="{active: activeYear==2019}"
              @click="activeYear=2019">2019</a></li>
            <li><a href="javascript:;" :class="{active: activeYear==2020}"
              @click="activeYear=2020">2020</a></li>
          </ul>

          <div class="chart-wrapper">
            <highcharts class="graphcontainer pie" :options="activeCatShare"></highcharts>
            <div class="nb">NB: Numbers may not total 100.0% due to rounding.</div>
          </div>
        </figure>
      </div>
    </article>
    <div class="fullbg">
      <p class="caption">Photo: <em>ILBIJERRI Ensemble: Conversations with the Dead</em>, ILBIJERRI Theatre Company, Photo Credit: Jeff Busby</p>
      <div class="overlay"></div>
    </div>
  </section>
</template>

<script>
/*eslint-disable */
export default {
  data () {
    return {
      activeYear: 2019,
      trends: {
        chart: {
          type: 'column',
          backgroundColor: 'transparent'
        },
        title: {
          style: { color: '#fff' },
          text: 'Total Revenue and Attendance'
        },
        legend: {
          itemStyle: { color: '#fff', fontWeight: 'normal' },
          itemHoverStyle: { color: '#fff' }
        },
        xAxis: {
          categories: [2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020],
          labels: {
            style: {
              color: '#fff'
            }
          }
        },
        yAxis: [{ // Primary yAxis
          min: 0,
          labels: {
            formatter () {
              if (this.value > 999) {
                // return this.key +'<br />'+this.y+'% '
                return '$' + (this.value / 1000) + 'b'
              } else {
                return '$' + this.value + 'm'
              }
            },
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Gross Revenue',
            style: {
              color: '#fff'
            }
          },
          opposite: true
        }, { // Secondary yAxis
          min: 0,
          labels: {
            format: '{value}m',
            style: {
              color: '#fff'
            }
          },
          title: {
            text: 'Total Attendance',
            style: {
              color: '#fff'
            }
          },
          opposite: false
        }],
        tooltip: {
          shared: true,
          formatter () {
            let revy, tooltipstring, avg;
            let rev = this.points[0];
            let att = this.points[1];
            let atty = att.y.toFixed(2) + 'm';
            let chart = this.points[0].series.chart;
            let categories = chart.xAxis[0].categories;
            let index = 0;
            while (this.x !== categories[index]) {
              index++;
            }
            for (let i=0; i<chart.series.length; i++) {
              let series = chart.series[i];
              avg = series.data[index].y;
            }
            if (rev.y > 1000) {
              revy = '$' + (rev.y / 1000).toFixed(2) + 'b'
            }
            else {
              revy = '$' + rev.y + 'm'
            }
            tooltipstring = this.x + '<br />';
            tooltipstring += '<span style="color:' + att.series.color + '">•</span> Attendance: ' + atty + '<br />'
            tooltipstring += '<span style="color:' + rev.series.color + '">•</span> Revenue: ' + revy
            return tooltipstring
          }
        },
        series: [
          {
            name: 'Revenue',
            data: [347.305, 451.053, 385.644, 344.389, 473.517, 450.034, 436.934, 440.33, 639.877, 600.318, 627.379, 158.294],
            color: '#3a89eb',
          },
          {
            name: 'Attendance',
            data: [4.744, 5.821, 5.36, 4.917, 5.607, 5.319, 5.548, 5.431, 7.364, 7.52, 7.408, 1.547],
            color: '#d14967',
            type: 'column',
            yAxis: 1,
          }
        ]
      },
      catShares: [
        {
          year: 2019,
          revenue: [
            ['Ballet and Dance', 3.15],
            ['Children\'s Family', 2.09],
            ['Circus and Physical Theatre', 0.70],
            ['Classical Music', 4.39],
            ['Comedy', 7.31],
            ['Contemporary Music', 40.41],
            ['Festivals (Multi-Category)', 1.10],
            ['Festivals (Contemporary Music)', 4.42],
            ['Musical Theatre', 18.83],
            ['Opera', 1.25],
            ['Special Events', 0.22],
            ['Theatre', 16.13]
          ],
          attendance: [
            ['Ballet and Dance', 2.76],
            ['Children\'s Family', 4.46],
            ['Circus and Physical Theatre', 1.41],
            ['Classical Music', 5.74],
            ['Comedy', 16.46],
            ['Contemporary Music', 32.85],
            ['Festivals (Multi-Category)', 6.82],
            ['Festivals (Contemporary Music)', 3.23],
            ['Musical Theatre', 15.49],
            ['Opera', 1.36],
            ['Special Events', 0.59],
            ['Theatre', 8.83]
          ]
        },
        {
          year: 2020,
          revenue: [
            ['Ballet and Dance', 0.33],
            ['Children\'s Family', 1.05],
            ['Circus and Physical Theatre', 1.68],
            ['Classical Music', 4.06],
            ['Comedy', 3.06],
            ['Contemporary Music', 51.61],
            ['Festivals (Multi-Category)', 0.83],
            ['Festivals (Contemporary Music)', 6.15],
            ['Musical Theatre', 15.76],
            ['Opera', 0.26],
            ['Special Events', 0.11],
            ['Theatre', 15.10]
          ],
          attendance: [
            ['Ballet and Dance', 0.39],
            ['Children\'s Family', 3.28],
            ['Circus and Physical Theatre', 2.84],
            ['Classical Music', 6.25],
            ['Comedy', 4.45],
            ['Contemporary Music', 46.31],
            ['Festivals (Multi-Category)', 3.16],
            ['Festivals (Contemporary Music)', 5.00],
            ['Musical Theatre', 15.30],
            ['Opera', 0.45],
            ['Special Events', 2.08],
            ['Theatre', 10.48]
          ]
        },
      ]
    }
  },
  computed: {
    activeCatShare () {
      const self = this

      for (let i = 0; i < self.catShares.length; i++) {
        const catShare = self.catShares[i]
        if (catShare.year === self.activeYear) {
          return {
            chart: {
              type: 'pie',
              backgroundColor: 'transparent'
            },
            title: {
              text: ''
            },
            subtitle: {
              text: ''
            },
            plotOptions: {
              series: {
                states: {
                  inactive: {
                    opacity: 1
                  }
                }
              },
              pie: {
                shadow: false,
                center: ['50%', '50%'],
                dataLabels: {
                  enabled: true,
                  style: {
                    fontWeight: 'bold',
                    color: 'white',
                    textShadow: '0px 1px 2px black'
                  }
                },
                point: {
                  events: {
                    legendItemClick (e) {
                      e.preventDefault()
                      return false
                    }
                  }
                }
              }
            },
            tooltip: {
              valueSuffix: '%',
              valueDecimals: 2
            },
            series: [{
              name: 'Attendance Share',
              data: catShare.attendance,
              size: '68%',
              innerSize: '40%',
              borderColor: 'none',
              borderWidth: 1,
              slicedOffset: 30,
              showInLegend: false,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none'
                },
                formatter () {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -28
              },
              colors: ['#F7977A', '#82CA9D', '#6ECFF6', '#7EA7D8', '#8882BE', '#BC8DBF', '#70CB92', '#ACDFF4']
            },
            {
              name: 'Revenue Share',
              data: catShare.revenue,
              size: '100%',
              innerSize: '70%',
              borderColor: 'transparent',
              borderWidth: 1,
              dataLabels: {
                color: '#000',
                style: {
                  textShadow: 'none'
                },
                formatter () {
                  if (this.y > 3) {
                    return this.y.toFixed(1) + '% '
                  }
                },
                distance: -28
              },
              colors: ['#F7977A', '#82CA9D', '#6ECFF6', '#7EA7D8', '#8882BE', '#BC8DBF', '#70CB92', '#ACDFF4']
            }],
            responsive: {
              rules: [{
                condition: {
                  maxWidth: 400
                },
                chartOptions: {
                  series: [{
                  }, {
                    id: 'versions',
                    dataLabels: {
                      enabled: false
                    }
                  }]
                }
              }]
            }
          }
        }
      }

      return false
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped="scoped">
.chart-wrapper {
  position: relative;
  .nb {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    font-style: italic;
    font-size: 12px;
  }
}
</style>
